import styled from 'styled-components'

interface GlobalViewToggleProsp {
  active: boolean
}

export const GlobalViewToggle = styled.div<GlobalViewToggleProsp>`
  min-width: 60px;
  height: 60px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
  border-radius: 12.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg {
    fill: ${(props) =>
      props.active ? props.theme.colorOrange : props.theme.colorLightGray} !important;
    height: 35px;
    width: 35px;
  }
`

export const GlobalViewControls = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 500px) {
    display: none;
  }
`

export const GlobalViewMobileMenu = styled.div`
  display: none;
  position: relative;
  min-width: 60px;
  width: 60px;
  height: 60px;
  margin-left: 1rem;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
  border-radius: 12.5px;
  align-items: center;
  justify-content: center;
  svg {
    fill: ${(props) => props.theme.black} !important;
    height: 35px;
    width: 35px;
  }

  @media (max-width: 500px) {
    display: flex;
  }
`

export const GlobalViewMobileOptions = styled.div<{ open?: boolean }>`
  position: absolute;
  top: 125%;
  right: 0;
  width: fit-content;
  height: max-content;
  display: flex;
  flex-direction: column;
  transition: 0.2s ease;
  padding: 1rem;
  ${({ open }) => (open ? 'min-height:11rem; height:20rem' : 'height:0; padding:0')};
  overflow: hidden;
  background-color: white;
  z-index: 999;
  border-radius: 10px;
  gap: 1rem;
  * {
    z-index: 9999;
  }
`

/** Matches satellite imagery base tone so loading never flashes white/gray before tiles appear */
export const MAP_BASE_BACKGROUND = '#1e2126'

export const GlobalViewMapContainer = styled.div`
  width: 100%;
  height: 100vh;
  border-radius: 10px;
  background-color: ${MAP_BASE_BACKGROUND};
`

/** Shown while Google Maps JS API is loading (Wrapper has no map div yet) */
export const MapLoadingPlaceholder = styled.div`
  width: 100%;
  height: 100vh;
  border-radius: 10px;
  background-color: ${MAP_BASE_BACKGROUND};
`

export const GlobalViewSelect = styled.div`
  font-weight: 600;
  font-size: 11.6688px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
  border-radius: 12.5px;
  min-width: 140px;
  height: 60px;
  position: relative;
  cursor: pointer;
`

export const GlobalViewOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  position: absolute;
  top: 110%;
  left: 0;
  z-index: 9;
`

export const GlobalViewSelectOption = styled.div`
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
  border-radius: 12.5px;
  width: 140px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 20px;

  &:hover {
    color: ${(props) => props.theme.colorOrange};
  }
`

export const GlobalViewContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  position: absolute;
  padding: 6rem 1rem;
  padding-bottom: 1rem;
  left: 0;
  bottom: 0;
  gap: 2rem;
`

export const GlobalViewFilterContainer = styled.div<{ open?: boolean }>`
  ${({ open }) => (open ? 'left:1rem;opacity:1;' : 'left:-100%;opacity:0;')}
  position: absolute;
  border-radius: 10px;
  width: 250px;
  height: 88vh;
  transition: 0.2s ease-out;
  z-index: 999;
  padding: 1rem;
  ${(props) => props.theme.glassCard}
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const GlobalViewWidgetsContainer = styled.div<{ closed?: boolean }>`
  ${({ closed }) => (closed ? 'transform:translateX(-100%);opacity:0;' : '')}
  transition: .2s ease-out;
  display: flex;
  flex-direction: column;
  min-width: 170px;
  gap: 10px;
  overflow: auto;
  z-index: 9999;
  height: 88vh;
  padding-bottom: 1rem;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const GlobalViewDetailsContainer = styled(GlobalViewWidgetsContainer)`
  ${({ closed }) => (closed ? 'transform:translateX(110%);opacity:0;' : 'transform:translateX(0);')}
  position: absolute;
  right: 1rem;
  min-width: 330px;
  max-width: 330px;
  padding: 1rem;
  padding-top: 5.5rem;
  opacity: 1;
  ${(props) => props.theme.container};
  overflow: visible;
`

export const GLDetailsHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  border-radius: 10px;
  background: ${(props) => props.theme.colorOrange};
  display: flex;
  justify-content: space-between;
  padding: 2rem;
`

export const GLDetailsHeaderTitle = styled.div`
  display: flex;
  gap: 10px;
  img {
    width: 45px;
    width: 45px;
    max-height: 45px;
    border-radius: 50%;
    border: 2px solid white;
  }
  .text {
    display: flex;
    flex-direction: column;
  }
`

export const GLDetailsCardContainer = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  position: relative;
`

export const GLDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 5px;
`

export const GLDetailsStartEnd = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  div {
    display: flex;
    flex-direction: column;
  }
`

export const GLDetailsCard = styled.div`
  /* Dropdown */
  z-index: 999;
  width: 100%;
  height: max-content;
  padding: 1rem;

  border-radius: 12px;
  ${(props) => props.theme.glassCard}
  .title {
    margin-bottom: 10px;
  }

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`

export const GLDetailsHeaderRating = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  height: min-content;
`

export const GlobalViewWidget = styled.div`
  min-width: 170px;
  padding: 1rem;
  border-radius: 10px;
  transition: 0.2s ease-in;
  ${(props) => props.theme.container};
`

export const GloblViewWidgetTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

export const GlobalViewWidgetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 1rem;
`

export const WidgetBarContainer = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  padding: 4px;
  &:hover {
    background: ${(props) => (props.theme.appBackground === '#333333' ? '#505e62' : '#f1f1f1ff')};
    outline: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
  }
  ${(props) =>
    props.selected && 'border-left:2px solid #ff9900; border-radius:8px; padding-left:1.5rem;'}
`

export const WidgetBarInfoContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  flex-direction: column;
`

export const WidgetBar = styled.div<{ color: string; width?: string }>`
  width: ${(props) => props.width || '10px'};
  position: relative;
  background: ${(props) => props.color};
  height: 10px;
  border-radius: 3px;
  backdrop-filter: blur(13.2px);

  &::after {
    content: '';
    background: ${(props) => props.color};
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: ${(props) => props.color};
    border-radius: 3px;
    filter: blur(2.7px);
  }
`

export const AskAiContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  align-self: flex-end;
`

export const AskAiButton = styled.div<{ width?: string; cursor?: string }>`
  width: ${(props) => props.width || '150px'};
  height: 50px;
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: ${(props) => props.cursor || 'pointer'};
  box-sizing: border-box;
  border-radius: 10px;
  transition: 0.2s ease;
  padding: 0 1rem;
  ${(props) => props.theme.glassCard}
  &:hover {
    background: ${(props) => props.theme.glassHover};
  }

  input {
    width: 100%;
    height: 100%;
    background: transparent;
    border: none;
    outline: none;
    color: ${(props) => props.theme.textColor};
    font-size: 16px;
    padding-left: 10px;
    &::placeholder {
      color: ${(props) => props.theme.textColor};
      opacity: 0.5;
    }

    ::-ms-input-placeholder {
      /* Edge 12 -18 */
      color: rgba(255, 255, 255, 0.74);
    }
  }
`

export const AIChatContainer = styled.div<{ open?: boolean; darken?: boolean }>`
  ${({ open }) => (open ? 'height: 450px;padding:1rem;' : 'height: 0px;padding:0;')};
  overflow: hidden;
  transition: 0.3s ease-in;
  position: absolute;
  left: 0;
  bottom: 110%;
  width: 100%;
  max-height: 450px;
  display: flex;
  gap: 1rem;
  z-index: 999;
  background: ${(props) => (props.darken ? 'rgba(34, 32, 32, 0.7)' : 'rgba(34, 32, 32, 0.3)')};
  box-shadow: 0px 354px 142px rgba(0, 0, 0, 0.01), 0px 199px 120px rgba(0, 0, 0, 0.05),
    0px 89px 89px rgba(0, 0, 0, 0.09), 0px 22px 49px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2.845px);
  border-radius: 10px;
`

export const AIChatHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: auto;
  width: 30%;
  padding: 0 15px;
`

export const AIChatHistoryItem = styled.div`
  color: white;
  min-height: 28px;
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  animation: 0.2s ease-in;
  padding: 5px 10px;
  p {
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    background: rgba(34, 32, 32, 0.3);
    box-shadow: 0px 354px 142px rgba(0, 0, 0, 0.01), 0px 199px 120px rgba(0, 0, 0, 0.05),
      0px 89px 89px rgba(0, 0, 0, 0.09), 0px 22px 49px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(2.845px);
    border-radius: 6px;
  }
`

export const AICurrentChat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
  width: 70%;
`

export const AIChatResponse = styled.div`
  display: flex;
  p {
    color: white;
  }
`

export const AIChatQuestion = styled.div`
  width: auto;
  display: flex;
  justify-content: flex-end;
  width: 100%;

  .content {
    /* Dropdown */
    ${(props) => props.theme.glassCard}
    border-radius: 12px;
    padding: 1rem;
  }
`

export const SelectedPins = styled.div<{ closed: boolean }>`
  // TODO nasledi isti div
  ${({ closed }) => (closed ? 'transform:translateX(100%);opacity:0;pointer-events:none;' : '')}
  transition: .2s ease-out;
  display: flex;
  flex-direction: column;
  align-items: end;
  min-width: 105px;
  gap: 10px;
  z-index: 9999;
  height: 88vh;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const SelectedPinContainer = styled.div`
  position: relative;
  border-radius: 10px;
  width: 90px;
  min-height: 110px;
  padding: 1rem 0;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  ${(props) => props.theme.glassCard}
  overflow: visible; // TODO

  img {
    width: 44px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    border: 1px solid ${(props) => props.theme.textColor};
    outline: none;
  }
`

export const SelectedPinAction = styled.div`
  cursor: pointer;
  position: absolute;
  left: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.theme.glassCard}
  width: 30px;
  height: 30px;
  border-radius: 10px;
  z-index: 9999;
`

export const ShiftTimelineContainer = styled.div`
  display: flex;
  height: 10px;
  overflow: hidden;
  margin-bottom: 8px;
  gap: 2px;
  position: relative;
  padding: 0 2px;

  .line {
    position: absolute;
    width: 100%;
    height: 1px;
    border-radius: 2px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${(props) => props.theme.colorLightGray};
    z-index: 1;
  }
`

export const ShiftTimelineSegment = styled.div<{ type: 'task' | 'free'; width: string }>`
  width: ${(props) => props.width}%;
  background-color: ${(props) =>
    props.type == 'task' ? props.theme.colorOrange : props.theme.colorYellow};
  opacity: 0.74;
  border-radius: 3px;
  z-index: 3;
`

export const ShiftTimeLegend = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
`

export const LegendColor = styled.div<{ color?: string }>`
  width: 4px;
  height: 4px;
  border-radius: 1px;
  background-color: ${(props) => props.color};
`

export const TripCard = styled.div`
  width: 100%;
  ${(props) => props.theme.container};
  border: 1px solid ${(props) => props.theme.thinSeparator};
  cursor: pointer;

  .top {
    border-bottom: 1px solid ${(props) => props.theme.thinSeparator};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
  }

  .bottom {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
`
